<template>
  <div>
    <Page404 v-if="!providedFeaturesGmb" />
    <section v-else class="p-box">
      <form>
        <div class="p-box__body">
          <Loading v-show="googleOauthLoading" />
          <template v-if="googleOauthLoading" />
          <template v-else-if="hasGoogleOauth">
            <template v-if="!hasRefreshToken">
              <div class="p-box__info">
                <div class="c-info">
                  <div class="c-info__icon">
                    <Icon name="iconQuestion" />
                  </div>
                  <div class="c-info__content">
                    <i18n-t keypath="pages.companies.googleOauth.recommendToReconnect" tag="p">
                      <a target="_blank" href="https://myaccount.google.com/permissions">{{ $t('pages.companies.googleOauth.googlePermissionPath') }}</a>
                    </i18n-t>
                  </div>
                </div>
              </div>
              <p class="u-colorPrimary">
                {{ $t('messages.disabledConnectionWith', { value: googleOauth.attributes.email }) }}
                <br>
              </p>
            </template>
            <template v-else>
              <div class="p-box__info">
                <div class="c-info">
                  <div class="c-info__icon">
                    <Icon name="iconQuestion" />
                  </div>
                  <div class="c-info__content">
                    <i18n-t keypath="pages.companies.googleOauth.info1" tag="p">
                      <a target="_blank" href="https://myaccount.google.com/permissions">{{ $t('pages.companies.googleOauth.googlePermissionPath') }}</a>
                    </i18n-t>
                    <p>{{ $t('pages.companies.googleOauth.info2') }}</p>
                  </div>
                </div>
              </div>
              <p class="connected-mail u-colorPrimary">
                {{ $t('labels.connectingWith', { value: googleOauth.attributes.email }) }}
                <br>
              </p>
            </template>
          </template>
          <template v-else>
            {{ $t('messages.notConnectedWith', { value: $t('labels.googleAccount') }) }}
            <div class="c-button c-button--right">
              <a :href="`/google_oauth/authorization/new?company_uuid=${ companyUuid }`" class="c-button__item c-button__item--primary">
                {{ $t('labels.connectWith', { value: $t('labels.googleAccount') }) }}
              </a>
            </div>
          </template>
        </div>
        <footer v-if="!googleOauthLoading" class="p-box__footer">
          <div v-if="hasGoogleOauth && (isAdmin || isDistributer)" class="c-button c-button--icon c-button--right">
            <button class="c-button__item" @click="onDeleteSubmit">
              <div class="c-button__icon">
                <img :src="iconCrossPath" alt="">
              </div>
              {{ $t('labels.cancelConnection') }}
            </button>
          </div>
        </footer>
      </form>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Loading from '../components/Loading.vue'
import Icon from '../components/Icon'
import iconCrossPath from '../../../images/common/icon_cross.svg'
import Page404 from '../views/Page404'

export default {
  name: 'CompaniesGoogleOauth',
  components: {
    Loading,
    Icon,
    Page404
  },
  data () {
    return {
      companyUuid: this.$route.params.company_uuid,
      iconCrossPath,
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'companiesAccessibleApi/isAdmin',
      isDistributer: 'companiesAccessibleApi/isDistributer',
      providedFeaturesGmb: 'companiesCompany/providedFeaturesGmb',
    }),
    ...mapState({
      googleOauth: state => state.companiesGoogleOauth.data,
      googleOauthLoading: state => state.companiesGoogleOauth.loading,
    }),
    hasGoogleOauth: function() {
      return !!this.googleOauth
    },
    hasRefreshToken: function() {
      return this.googleOauth?.attributes?.has_refresh_token
    },
  },
  created() {
    this.readGoogleOauth(this.companyUuid)
  },
  methods: {
    ...mapActions({
      readGoogleOauth: 'companiesGoogleOauth/readGoogleOauth',
      deleteBusinessGroup: 'companiesGmbAccounts/deleteCompaniesGmbAccount',
    }),
    showMessage: function (val) {
      if (val) this.$updateFlash({ type: 'notice', message: val })
    },
    showError: function (val) {
      if (val) this.$updateFlash({ type: 'alert', message: val })
    },
    onDeleteSubmit: async function () {
      if (!confirm(this.$t('pages.companies.googleOauth.confirmToDelete'))) return
      const payload = {
        companyUuid: this.companyUuid
      }
      const isSuccess = await this.deleteBusinessGroup(payload)
      if (isSuccess) this.readGoogleOauth(this.companyUuid)
    }
  }
}
</script>

<style lang="scss" scoped>
.connected-mail {
  margin-bottom: 8px;
}
</style>
